import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/pledge/list',
      data
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/pledge/add',
      data,
      dataType: 'form'
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/pledge/update',
      data,
      dataType: 'form'
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  }
};
